import React from 'react';
import { AbsoluteFill, useCurrentFrame, interpolate, spring } from 'remotion';

// 减压动画
export const StressReliefAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  
  const breathScale = spring({
    frame,
    from: 0.8,
    to: 1.2,
    fps: 30,
    config: { damping: 5, stiffness: 50 },
  });

  const breathOpacity = interpolate(frame, [0, 60, 120], [0.3, 1, 0.3], { extrapolateRight: 'clamp' });

  const tips = [
    '深呼吸',
    '放松肩膀',
    '闭眼冥想',
  ];

  return (
    <AbsoluteFill style={{
      background: 'radial-gradient(circle, #a8edea 0%, #fed6e3 100%)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#2d3436',
    }}>
      <h1 style={{ fontSize: 70, marginBottom: 60 }}>
        减压放松 🧘
      </h1>

      {/* 呼吸圆圈 */}
      <div style={{
        width: 300 * breathScale,
        height: 300 * breathScale,
        background: `rgba(102, 126, 214, ${breathOpacity * 0.5})`,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 60,
        boxShadow: '0 0 100px rgba(102, 126, 214, 0.4)',
      }}>
        <span style={{ fontSize: 50, fontWeight: 'bold' }}>
          吸气
        </span>
      </div>

      {/* 提示 */}
      <div style={{ display: 'flex', gap: 30, marginTop: 40 }}>
        {tips.map((tip, i) => {
          const opacity = interpolate(frame, [i * 20, i * 20 + 20], [0, 1], { extrapolateRight: 'clamp' });
          return (
            <div key={i} style={{
              padding: '20px 40px',
              background: 'rgba(255,255,255,0.6)',
              borderRadius: 20,
              fontSize: 32,
              opacity,
            }}>
              {tip}
            </div>
          );
        })}
      </div>

      <p style={{ marginTop: 60, fontSize: 28, opacity: 0.7 }}>
        💡 每天练习5分钟，缓解压力
      </p>
    </AbsoluteFill>
  );
};
